var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 25,
    viewBox: "0 0 23 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 12.5,
    r: 11.5,
    fill: "#FFBCBC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0811 14.7373H10.9365L10.4883 6.15039H13.5293L13.0811 14.7373ZM10.4531 17.7432C10.4531 17.1924 10.6025 16.8057 10.9014 16.583C11.2061 16.3604 11.5723 16.249 12 16.249C12.416 16.249 12.7734 16.3604 13.0723 16.583C13.377 16.8057 13.5293 17.1924 13.5293 17.7432C13.5293 18.2705 13.377 18.6514 13.0723 18.8857C12.7734 19.1201 12.416 19.2373 12 19.2373C11.5723 19.2373 11.2061 19.1201 10.9014 18.8857C10.6025 18.6514 10.4531 18.2705 10.4531 17.7432Z",
    fill: "#980000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning_icon.b42c10e94ff6862699df32aeada2dc6e.svg";
export { ForwardRef as ReactComponent };